import React, { useState, useEffect, useRef } from 'react';
import LogoImg from "../assets/images/logo-white.svg";
import AccessibilityImg from "../assets/images/icons/accessibility.svg";
import { RxHamburgerMenu } from "react-icons/rx";
import { IoCloseOutline } from "react-icons/io5";
import { useSelector, useDispatch } from "react-redux";
import { setIsAuthenticated, setPageUrl } from "../redux/reducers/authSlice";
import { setUserData } from "../redux/reducers/masterDataSlice";
import { setShowMoreTag } from '../redux/reducers/commonSlice';
import { useNavigate, Link } from 'react-router-dom';
import AutoLogout from "./autoLogOut"

function Header(props) {
    const { isAuthenticated } = useSelector((state) => state.authentication);
    const { userData } = useSelector((state) => state.masterData);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const menuClick = () => {
        const element = document.getElementById("navbarSupportedContent");
        if (element) {
            element.classList.toggle("show"); 
            element.classList.toggle("hide"); 
        }
    };
    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };
    const handleLogout = () => {
        logout()
    };

    const logout = () => {
        dispatch(setIsAuthenticated(false));
        dispatch(setUserData([]));
        dispatch(setPageUrl("/"));
        setTimeout(() => {
            window.location.href = "/";
        }, 500);
    };
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    const mediaListFn = () => {
        if ((userData.roleDisplayName === "Super_admin" || userData.roleDisplayName === "APPROVER") && props?.setMediaListFlag) {
            props?.setMediaListFlag(true)
        }
        navigate("/video-list")
    }
    const logoFn = () => {
        dispatch(setShowMoreTag(false))
        // props.setShowMore(false)
        navigate("/")
    }

    return (
        <header>
            {/* <AutoLogout onLogout={handleLogout} /> */}
            <div className='top-header py-1'>
                <div className='container position-relative'>
                    <div className='top-header-text'>
                        102 Nationalists can reach visit visa-free.
                        <a href="https://visitqatar.com/intl-en/plan-your-trip/visas" className='top-header-a ms-1'>Know More</a>
                    </div>
                </div>
            </div>
            <nav className="navbar navbar-expand-lg py-0">
                <div className="container">
                    <span className="cursor-pointer navbar-brand py-0"
                    onClick={() => logoFn()}>
                        <img src={LogoImg} className='logo-img' alt='Logo' width={100} height={70} />
                    </span>
                    {/* <span className='ms-auto displayname'>
                    {userData.userDisplayName.replace(/([A-Z])/g, ' $1').trim()}
                    </span> */}
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" onClick={() => { menuClick() }}>
                        <RxHamburgerMenu className="navbar-toggler-icon" />
                    </button>
                    <div className="navbar-collapse hide" id="navbarSupportedContent">
                        <IoCloseOutline className='close-icon' onClick={() => { menuClick() }} />
                        <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                            <li className="nav-item">
                                <Link className="nav-link active" aria-current="page" to="https://visitqatar.com/intl-en/about-qatar">About Qatar</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" to="#">Support</Link>
                            </li>
                            {(!isAuthenticated) &&
                                <li className="nav-item">
                                    <Link className="nav-link" to="/login">Login / Signup</Link>
                                </li>
                            }
                            {(isAuthenticated) &&
                                <li className="nav-item dropdown" ref={dropdownRef}>
                                    <Link
                                        className="nav-link dropdown-toggle"
                                        to="#"
                                        id="navbarDropdown"
                                        role="button"
                                        aria-expanded={isOpen ? 'true' : 'false'}
                                        onClick={toggleDropdown}
                                    >
                                        {userData?.userDisplayName?.replace(/([A-Z])/g, ' $1').trim()}
                                    </Link>
                                    <ul className={`dropdown-menu ${isOpen ? 'show' : ''}`} aria-labelledby="navbarDropdown">
                                        {(userData.roleDisplayName !== "User" && userData.roleDisplayName !== "APPROVER") &&
                                            <li><Link className="dropdown-item" to="/tags-directory">Tags Directory</Link></li>
                                        }
                                        {userData.roleDisplayName === "Super_admin" &&
                                            <>
                                                <li><Link className="dropdown-item" to="/approver-list">Approver List</Link></li>
                                                <li><Link className="dropdown-item" to="/admin-list">Admin List</Link></li>
                                            </>
                                        }
                                        {(userData.roleDisplayName === "Super_admin" || userData.roleDisplayName === "APPROVER") &&
                                                <li><Link className="dropdown-item" to="/user-list">User List</Link></li>
                                        }
                                        {(userData.roleDisplayName !== "User") &&
                                            <li><span className="dropdown-item"
                                                onClick={() => mediaListFn()}>Media List</span></li>
                                        }
                                        {(userData.roleDisplayName === "Super_admin" || userData.roleDisplayName === "APPROVER") &&
                                            <li><Link className="dropdown-item" to="/video-request">Requests</Link></li>
                                        }
                                        <li><Link className="dropdown-item cursor-pointer"
                                            onClick={() => {
                                                logout();
                                            }}>Log out</Link></li>
                                    </ul>
                                </li>
                            }
                            {/* <li className="nav-item">
                                <a className="nav-link px-0" href="#">
                                    <img src={AccessibilityImg} alt='accessibility' width={30} height={28} />
                                </a>
                            </li> */}
                        </ul>
                    </div>

                    {/* <div className="d-flex align-items-center order-1 login-link">

                        <div className="flex-shrink-0 dropdown">
                            <ul className="navbar-nav ms-auto m-0">
                                {(!isAuthenticated) &&
                                    <li className="nav-item">
                                        <a className="nav-link" href="/login">Login / Signup</a>
                                    </li>
                                }
                                {(isAuthenticated) &&
                                    <li className="nav-item dropdown" ref={dropdownRef}>
                                        <a
                                            className="nav-link dropdown-toggle"
                                            href="#"
                                            id="navbarDropdown"
                                            role="button"
                                            aria-expanded={isOpen ? 'true' : 'false'}
                                            onClick={toggleDropdown}
                                        >
                                            {userData.userDisplayName.replace(/([A-Z])/g, ' $1').trim()}
                                        </a>
                                        <ul className={`dropdown-menu ${isOpen ? 'show' : ''}`} aria-labelledby="navbarDropdown">
                                            {userData.roleDisplayName === "Super_admin" &&
                                                <>
                                                    <li><a className="dropdown-item" href="/admin-list">Admin List</a></li>
                                                    <li><a className="dropdown-item" href="/user-list">User List</a></li>
                                                </>
                                            }
                                            {((userData.roleDisplayName === "Super_admin") || (userData.roleDisplayName === "Admin")) &&
                                                <li><a className="dropdown-item" href="/video-list">Video List</a></li>
                                            }
                                            {userData.roleDisplayName === "Super_admin" &&
                                                <li><a className="dropdown-item" href="/video-request">Requests</a></li>
                                            }
                                            <li><a className="dropdown-item cursor-pointer"
                                                onClick={() => {
                                                    logout();
                                                }}>Log out</a></li>
                                        </ul>
                                    </li>
                                }
                            </ul>
                        </div>
                    </div> */}
                </div>
            </nav>
        </header>
    );
}

export default Header;
